/**
 * Sehr kleiner Pfad-Router.
 *
 * Anders als bei App und Portal (Hash-Routing) braucht die öffentliche
 * Website echte, teilbare und von Suchmaschinen lesbare Pfade wie
 * `/impressum`. Die nginx-Regel liefert für jeden Pfad `index.html` aus
 * (`try_files … /index.html`), dieser Router übernimmt danach anhand von
 * `location.pathname`.
 */

function ausPfad(): string {
  return location.pathname;
}

class Router {
  pfad = $state(ausPfad());

  constructor() {
    addEventListener('popstate', () => {
      this.pfad = ausPfad();
    });
  }
}

export const router = new Router();

export function geheZu(pfad: string): void {
  if (pfad === location.pathname) return;
  history.pushState({}, '', pfad);
  router.pfad = pfad;
  scrollTo({ top: 0 });
}
